// @flow
import React from 'react';

const T2Spinner = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none" viewBox="0 0 80 80">
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M40 6.667V20m0 40v13.333m-23.567-56.9l9.434 9.434m28.266 28.266l9.434 9.434M6.667 40H20m40 0h13.333m-56.9 23.567l9.434-9.434m28.266-28.266l9.434-9.434"
        >
          <animateTransform
            attributeType="xml"
            attributeName="transform"
            type="rotate"
            from="0 40 40"
            to="360 40 40"
            dur="2.5s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </>
  );
};

export default React.memo(T2Spinner);
